export default {
  pt: {
    pageTitle: "Pagamento",
    mainTitle: "Como você prefere pagar?",
    description:
      "Agora você pode escolher pagar a entrada por PIX ou Cartão de Crédito. As parcelas seguem as condições de pagamento da HDI, com link enviado junto à emissão da sua apólice.",
    creditCardButton: "Cartão de crédito",
    pixButton: "Pix",
    howItWorksTitle: "Como funciona",
    howItWorksIntro:
      "Contratando o seguro pela  BikeHero, o valor que você paga é repartido entre a loja e a seguradora:",
    howItWorksItem1:
      "O valor da entrada é cobrado instantaneamente e é repassada integralmente pela loja, que será responsável pela inspeção da sua bike, garantindo a cobertura provisória pela seguradora.",
    howItWorksItem2:
      "O valor restante será cobrado diretamente pela seguradora juntamente com a emissão de sua apólice de seguro.",
    paymentOptionsTitle: "Como você prefere pagar?",
    installmentSectionTitle: "Parcelamento da segunda etapa",
    installmentLabel: "Parcelamento",
    installmentRequiredMessage: "Selecione uma opção de parcelamento",
    continueButton: "Continuar",
    totalLabel: "Total",
    loadErrorMessage: "Não foi possível carregar as opções de parcelamento. Tente novamente.",
    emptyInstallmentsMessage: "Nenhuma opção de parcelamento disponível para este plano.",
  },

  en: {
    pageTitle: "Payment",
    mainTitle: "How would you like to pay?",
    description:
      "You can now choose to pay the down payment via PIX or Credit Card. Installments follow HDI's payment terms, with the link sent along with your policy issuance.",
    creditCardButton: "Credit card",
    pixButton: "Pix",
    howItWorksTitle: "How it works",
    howItWorksIntro:
      "When you take out insurance through BikeHero, the amount you pay is split between the store and the insurer:",
    howItWorksItem1:
      "The down payment is charged instantly and passed entirely to the store, which is responsible for inspecting your bike, ensuring provisional coverage by the insurer.",
    howItWorksItem2:
      "The remaining amount will be charged directly by the insurer together with the issuance of your policy.",
    paymentOptionsTitle: "How would you like to pay?",
    installmentSectionTitle: "Second-stage installments",
    installmentLabel: "Installments",
    installmentRequiredMessage: "Select an installment option",
    continueButton: "Continue",
    totalLabel: "Total",
    loadErrorMessage: "Could not load the installment options. Please try again.",
    emptyInstallmentsMessage: "No installment options available for this plan.",
  },
};
